import { HeaderRepositoryController } from './header-repository.controller'

/* @ngInject */
function headerRepository () {
  return {
    restrict: 'E',
    scope: {
      breadcrumbs: '<',
      navigation: '<',
      toolbar: '<',
      headerTitle: '<'
    },
    templateUrl: '/core/directives/header-repository/header-repository-directive.html?$$REVISION$$',
    controller: HeaderRepositoryController
  }
}

export { headerRepository }
